/** Naming for the real (empty) form fields Sign PDF leaves for another person to fill: fdp_<type>_<n>_other */
export type SignFieldType = "signature" | "initial" | "date" | "fullName" | "initialsText";

const TYPES: SignFieldType[] = ["signature", "initial", "date", "fullName", "initialsText"];
const RE = /^fdp_(signature|initial|date|fullName|initialsText)_(\d+)_other$/;

export const otherFieldName = (type: SignFieldType, n: number) => `fdp_${type}_${n}_other`;

export function parseOtherFieldName(name: string): { type: SignFieldType; n: number } | null {
  const m = RE.exec(name);
  return m && TYPES.includes(m[1] as SignFieldType) ? { type: m[1] as SignFieldType, n: Number(m[2]) } : null;
}

export const OTHER_FIELD_TOOLTIP: Record<SignFieldType, string> = {
  signature: "Sign here",
  initial: "Initial here",
  date: "Date",
  fullName: "Full name",
  initialsText: "Initials",
};
